// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"114":"83347012","126":"b3f205f5"}[chunkId] + ".js";
};